// extracted by mini-css-extract-plugin
module.exports = {"container":"PageProgressSpinner_container__Fbfpd","spinner":"PageProgressSpinner_spinner__PMIzU","rotation":"PageProgressSpinner_rotation__RVq3S"};